import React from 'react';

class Promotion extends React.Component {
	render() {
		return(

			<div>
				<div className="navbar-top">
		          <div className="site-brand">
		            <div className="side-nav-panel-left">
			            <a href="/"> 
			              <i className="fa fa-arrow-left" style={{fontSize: '21px',color: '#F0592D', paddingRight: '8px'}}></i>
			            </a>
		            </div>
		          </div>
		          <div className="site-brand">
		            <a href="/"> 
		              <h2><span className="st2">XPRESS</span><span className="st1">Lite</span></h2>
		            </a>
		          </div>
		          
		        </div>
                <div className="pages section">
					<div className="container">
						<div className="assetsdownload">
							<div className="assetsdownload-content">
								
                    <h6 className="heading-top">Promotions and Transfers</h6>
                  

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘I’ (25 January, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Promotion_Posting_Grade_H_to_I_And_I_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘H’ (15 February, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Promotion_Posting_Grade_G_to_H_and_H_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘G’ (19 February, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Promotion_Posting_Grade_F_to_G_and_G_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘F’ (5 March, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Promotion_Posting_Grade_E_to_F_and_F_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘E’ (9 March, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Promotion_Posting_Grade_D_to_E_and_E_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘D’ (20 March, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Promotion_Posting_Grade_C_to_D_and_D_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

					<h6 className="heading-top">Promotions & Transfers (Corporate Cadre)</h6>

					
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘C’ (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/C_Cadre/Postings_Corporate_Cadre_Grade_B_to_C_and_C_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘B’ (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/C_Cadre/Postings_Corporate_Cadre_Grade_A1_to_B_and_B_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘A1’ (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/C_Cadre/Postings_Corporate_Cadre_Grade_A1_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘A’ (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/C_Cadre/Postings_Corporate_Cadre_Grade_A_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>


					<h6 className="heading-top">Promotions & Transfers (Refineries)</h6>
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘C’ (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Refineries/Posting_Refineries_Division_Grade_B_to_C_&_C_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘B’ (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Refineries/Posting_Refineries_Division_Grade_A1_to_B_&_B_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
					<h6 className="heading-top">Promotions & Transfers (Marketing)</h6>
				
        
        	<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘C’, HO (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_HO_B_to_C_and_C_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘B’, HO (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_HO_A1_to_B_and_B_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘A’, HO (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_HO_A_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘A1’, HO (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_HO_A1_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘C’, ER (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_ER_B_to_C_and_C_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘B’, ER (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_ER_A1_to_B_and_B_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘A1’, ER (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_ER_A1_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                   
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘C’, WR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_WR_B_to_C_&_C_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘B’, WR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_WR_A1_to_B_&_B_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘A1’, WR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_WR_A1_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘A’, WR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_WR_A_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘C’, SR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_SR_B_to_C_&_C_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘B’, SR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_SR_A1_to_B_&_B_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘A1’, SR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_SR_A1_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘A’, SR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_SR_A_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘C’, NR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_NR_B_to_C_&_C_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘B’, NR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_NR_A1_to_B_&_B_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘A1’, NR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_NR_A1_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers: Grade ‘A’, NR (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Mkt/Mktg_NR_A_Lateral_2021.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>



					<h6 className="heading-top">Promotions & Transfers (Pipelines)</h6>
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘C’ (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Pipelines/PL_Div_B_to_C_and_C_Lateral_Postings.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>
                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘B’ (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Pipelines/PL_Div_A1_to_B_and_B_Lateral_Postings.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘A1’ (08 April, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/Pipelines/PL_Div_A1_Lateral_Postings.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>


					<h6 className="heading-top">Promotions & Transfers (R&D)</h6>
					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘C’ (08 March, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/R&D/R&D_Postings_Gr_B_to_C_&_C_Lateral.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>

                    <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce'}}>
                      <div className="col">
                        
                      Promotions & Transfers : Grade ‘B’ (08 March, 2021)
                        
                      </div>
					  
                      <div className="col">
                      <ul class="cl_ul" >
								<li><a class="normallink" target="_blank" href="https://iocl.com/uploads/promotion_and_transfer/2021/R&D/R&D_Postings_Gr_A1_to_B_&_B_Lateral.pdf" download="">Download / Read PDF</a></li>
							
								
							</ul>
                      </div>
                      
                    </div>



                   


				


					
	
				

				 



				  </div>	
						</div>
					</div>	
				</div>
		      
				<div id="fakeLoader"></div>

				<div className="footer" style={{position:'relative', width:'100%', bottom:'0',}}>
					<div className="container">
					<div className="copyright">
							<span>Copyright © IndianOilXpress</span><br/>
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
                <a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
                <a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
				<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
				<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>
				
						</div>
					</div>
				</div>

			</div>

		)
	}
}

export default Promotion;


// WEBPACK FOOTER //
// ./src/promotion.js